import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { HiringRequest } from "../../../../orchestrator-api-client";

export const submitHiringReducer = (
  state: CustomerState,
  action: PayloadAction<HiringRequest>,
) => {
  state.job = {
    ...state.job,
    employerName: action.payload.employer!, // TODO: Must be set as non-nullable on swagger
    hireMonth: action.payload.hireMonth ?? undefined, // TODO: Must be set as non-nullable on swagger
    hireYear: action.payload.hireYear ?? undefined, // TODO: Must be set as non-nullable on swagger
  };
};
